<template>
  <app-layout>
    <template #header>
      <AppHead :title="getTitle" />
      <h2 class="title">
        Edit Customer {{ form.first_name }} {{ form.last_name }}  
        <jet-button class="btn-short ml-2" :goesTo="route('tu.terms', user)">Manage Payment Terms</jet-button>
      </h2>
      <flash-messages />
    </template>

    <div class="py-2">
      <div>
        <div class="bg-white p-3">
          <form @submit.prevent="store">
            <div class="row">
              <div class="form-group col-sm-6">
                <jet-label class="mb-1" for="first_name" value="First name" />
                <jet-input id="first_name"  type="text" class="form-control" v-model="form.first_name" />
                <jet-input-error :message="form.errors.first_name" class="mt-2" />
              </div>
              <div class="form-group col-sm-6">
                <jet-label class="mb-1" for="last_name" value="Last name" />
                <jet-input id="last_name"  type="text" class="form-control" v-model="form.last_name" />
                <jet-input-error :message="form.errors.last_name" class="mt-2" />
              </div>
            </div>

            <div class="row">
              <div class="form-group col-sm-6">
                <jet-label class="mb-1" for="email" value="Email" />
                <jet-input id="email"  type="text" class="form-control" v-model="form.email" />
                <jet-input-error :message="form.errors.email" class="mt-2" />
              </div>
              <div class="form-group col-sm-6">
                <jet-label class="mb-1" for="phone_number" value="Phone" />
                <jet-input id="phone_number"  type="text" class="form-control" v-model="form.phone_number" />
                <jet-input-error :message="form.errors.email" class="mt-2" />
                
                <div class="form-check mt-2">
                  <jet-checkbox id="allow_sms"  class="form-check"  v-model:checked="form.allow_sms" />
                  <jet-label for="allow_sms" value="Allow SMS to this number" />
                </div>
              </div>
            </div>     

            <div class="row">
              <div class="form-group col-sm-6">
                <jet-label class="mb-1" for="location_id" value="Location" />
                <select id="location_id" class="form-control" v-model="form.location_id">
                  <option :value="null">Unassigned</option>
                  <option v-for="address in locations" :key="address.id" :value="address.id">
                    {{ address.company_name }} {{ address.address1 }} {{ address.address1 }} {{ address.city }}, {{ address.state }} {{ address.postcode }}
                  </option>
                </select>
                <jet-input-error :message="form.errors.location_id" class="mt-2" />
        
                <p role="button" data-toggle="modal" data-target="#locationModal" class="mb-0 mt-2 text-primary" @click="openNewLocation"><i class="fas fa-plus mr-2"></i>New Location</p>
              </div>
            </div>  

            <AddNewLocation
              :states="states"
              :form="locationForm"
              @saveLocation="saveLocation"
            />

            <div class="bottom-button">
              <jet-button class="px-5" btnStyle="success" icon="fas fa-user" :disable="form.processing" type="submit">Update Customer</jet-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
  import AppLayout from '@/Layouts/AppLayout'
  import FileInput from '@/Shared/FileInput'
  import TextInput from '@/Shared/TextInput'
  import SelectInput from '@/Shared/SelectInput'

  import JetButton from '@/Jetstream/Button'
  import JetFormSection from '@/Jetstream/FormSection'
  import JetInput from '@/Jetstream/Input'
  import JetCheckbox from '@/Jetstream/Checkbox'
  import JetInputError from '@/Jetstream/InputError'
  import JetLabel from '@/Jetstream/Label'
  import JetActionMessage from '@/Jetstream/ActionMessage'
  import FlashMessages from '@/Shared/FlashMessages'
  import AddNewLocation from '@/Components/Modals/AddNewLocation'

  export default {
    components: {
      AppLayout,
      FlashMessages,
      FileInput,
      SelectInput,
      TextInput,
      JetActionMessage,
      JetButton,
      JetFormSection,
      JetInput,
      JetCheckbox,
      JetInputError,
      JetLabel,
      AddNewLocation
    },
    remember: 'form',
    props: {
      user: Object,
      locations: Array,
      states: Array
    },
    data() {
      return {
        form: this.$inertia.form({
          _method: 'put',
          first_name: this.user.first_name,
          last_name: this.user.last_name,
          email: this.user.email,
          location_id: this.user.location_id,
          phone_number: this.user.phone_number,
          allow_sms: this.user.allow_sms == 1
        }),
        locationForm: this.$inertia.form({
          location_user_id: this.user.id,
          company_name: this.user.company_name,
          address1: null,
          address2: null,
          city: null,
          state: null,
          postcode: null
        }),
      }
    },
    computed: {
      getTitle() {
        if (this.form.first_name) {
          return `Edit Customer ${this.form.first_name} ${this.form.last_name}`
        } else {
          return 'Edit Customer'
        }
      }
    },
    methods: {
      store() {
        this.form.post(this.route('tu.update', this.user.id))
      },
      openNewLocation() {
        this.form.location_id = null;
        $('#locationModal').modal('show')
      },
      
      saveLocation() {
        this.form.location_id = this.user.location_id
      }
    },
  }
</script>
